import { useState } from 'react';

const faqs = [
  {
    q: '最低起訂量是多少?',
    a: '依據不同劑型與配方複雜度，最低起訂量有所不同。一般膠囊最低起訂量約為 30,000 顆，歡迎洽詢業務人員確認您的需求。',
  },
  {
    q: '是否可以提供客製化配方？',
    a: '是的，康永生技擁有專業研發團隊，可根據客戶的功效需求、目標族群與市場定位，提供完全客製化的配方研發服務。',
  },
  {
    q: '從確認配方到完成生產約需多少時間？',
    a: '一般而言，從配方確認到樣品完成約需 2～4 週；樣品確認後進入量產，生產週期約 4～8 週，視訂單規模而定。',
  },
  {
    q: '是否提供包裝設計服務？',
    a: '康永生技提供標籤設計與包裝建議服務，也可配合客戶自行提供的設計稿進行生產，歡迎與業務人員進一步討論。',
  },
  {
    q: '產品是否符合台灣法規?',
    a: '我們熟悉台灣健康食品相關法規，可協助客戶進行產品標示審查與法規送審，確保產品合法上市。',
  },
  {
    q: '如何開始合作?',
    a: '歡迎透過官網聯絡表單、電話或 LINE 與我們聯繫，業務人員將盡快回覆您，並安排進一步的需求訪談。',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="py-20 bg-[#f7faf7]">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-14 lg:gap-20 items-start">
          {/* Left - Header */}
          <div className="w-full lg:w-1/3 flex-shrink-0">
            <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5 border border-green-200">
              常見問題
            </span>
            <h2 className="text-[#1a2e1a] font-bold leading-tight mb-6">
              您最常問的<br className="hidden sm:block" />問題解答
            </h2>
            <p className="text-gray-500 text-[1.0625rem] leading-[1.75] mb-8">
              如果您的問題不在列表中，歡迎直接聯絡我們的業務團隊。
            </p>
            <a
              href="/contact"
              className="whitespace-nowrap inline-flex items-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white font-semibold text-[0.9375rem] px-6 py-3 rounded-full transition-all duration-300 cursor-pointer"
            >
              聯絡我們
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          {/* Right - FAQ list */}
          <div className="w-full lg:w-2/3">
            <div className="space-y-3">
              {faqs.map((faq, idx) => (
                <div
                  key={idx}
                  className={`bg-white rounded-xl border transition-all duration-200 overflow-hidden ${
                    openIdx === idx ? 'border-[#4CAF50]/40' : 'border-gray-100'
                  }`}
                >
                  <button
                    className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                    onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                  >
                    <span className={`text-[1rem] font-semibold leading-snug pr-4 ${openIdx === idx ? 'text-[#4CAF50]' : 'text-[#1a2e1a]'}`}>
                      {faq.q}
                    </span>
                    <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-200 ${openIdx === idx ? 'bg-[#4CAF50] text-white' : 'bg-green-50 text-[#4CAF50]'}`}>
                      <i className={`text-sm transition-transform duration-200 ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`} />
                    </div>
                  </button>
                  {openIdx === idx && (
                    <div className="px-6 pb-5">
                      <p className="text-gray-600 text-[0.9375rem] leading-[1.75]">{faq.a}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
